<template src="./html/LeftSidebar.html"></template>

<script>
	export default {
		props: ['user', 'isAuth', 'menus'],
		data () {
			return {
				menu: null,
			}
		},
		watch: {
			$route() {
				this.loadMenu()
			},
			menus() {
				this.loadMenu()
			},
		},
		created() {
			this.loadMenu()
		},
		mounted() {
			$('.slimscrollsidebar').slimScroll({
				height: '100%',
				position: 'left',
				size: "6px",
				color: 'rgba(0,0,0,0.5)'
			});

			$('#side-menu').metisMenu()
		},
		methods: {
			loadMenu() {
				if(this.menus.length) {
					var menu = this.menus.find(function(element) {
						return element.active == true
					})
					this.menu = menu
				} else {
					this.menu = null
				}
			},
		},
	}
</script>


// WEBPACK FOOTER //
// src/components/partials/views/LeftSidebar.vue